// BCM-898 · PA12 — Post-shipment documents not received (slide 33). [Lavanya]
// Statuses 48 (IBD) / 49 (GRN, PF2,3) / 46 / 47 (PF4), rendered when the
// "Post-shipment documents not received" requirement is PRESENT (disambiguates the
// shared statuses — handled by the resolver). Informational only. Same construction
// as PA1/PA7 with the category switched. PF5 has no post-shipment stage.
import React from "react";
import DocumentsPendingCard from "../components/common/DocumentsPendingCard";
import { DOC_CATEGORY } from "../utils/constants";

const PA12PostShipmentDocuments = ({ row, viewOnly }) => (
  <DocumentsPendingCard
    row={row}
    category={DOC_CATEGORY.POST_SHIPMENT}
    title="Post-Shipment documents are not yet received"
    successTitle="All post-shipment documents have been received"
    subText="The batch will not move ahead unless the pending documents listed below are received."
    viewOnly={viewOnly}
  />
);

export default PA12PostShipmentDocuments;
